import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import BannerSliderMobile from 'components_v2/mobile/BannerSlider';
import AdCaller from 'helpers/ads/adCaller';
import s from './LoksabhaElectionResultWrapper.scss';
import MiniResultStatus from '../../../components/ElectionV2/common/MiniResultStatus/MiniResultStatus';
import Morebtn from '../../desktop/Morebtn';
import { TOI_LIVE_DOMAIN } from '../../../constants';
import ElectionBattle from '../../../components/ElectionV2/common/ElectionBattle/ElectionBattle';
import SwitchTabs from '../../../components/ElectionV2/common/SwitchTabs/SwitchTabs';
import LokSabhaSeating from '../../../components/ElectionV2/lokSabha/LokSabhaSeating/LokSabhaSeating';
import LokSabhaSeatingVS from '../../../components/ElectionV2/lokSabha/LokSabhaSeating/LokSabhaSeatingVS';
import SeatChangeTable from '../../../components/ElectionV2/common/SeatChangeTable/SeatChangeTable';
import Listingheader from '../../../routes/home/components/common/ListingheaderV2';
import HeaderTab from '../../../routes/home/components/desktop/HeaderTabV2/HeaderTab';
import InfoMsg from '../../../components/ElectionV2/common/InfoMsg/InfoMsg';
import { loadLokSabhaResult } from '../../../components/ElectionV2/loksabha_redux';
import LoaderSpinner from '../LoaderSpinner/LoaderSpinner';
import BannerSlider from '../../desktop/BannerSlider/BannerSlider';
import StateWrapper from '../../../components/ElectionV2/common/StateWrapper/StateWrapper';
import { createSlug } from '../../../utils/common';

class LoksabhaElectionResultWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.stateResultWrapRef = React.createRef();
    const { electionData } = this.props?.sectionData?.items || {};
    this.state = {
      activeTab: this.props.isStatesPage ? 2 : 1,
      expandDiv: false,
    };
    try {
      if (electionData) {
        const currentData = Object.values(electionData)
          .filter(e => e.resultUrl)
          .sort((a, b) => b.year - a.year)[0];
        if (currentData) {
          this.state.currentData = currentData;
        }
      }
    } catch (error) {
      //
    }
  }

  toggleClass = () => {
    if (this.state.expandDiv) {
      if (this.stateResultWrapRef.current) {
        this.stateResultWrapRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }
    this.setState({ expandDiv: !this.state.expandDiv });
  };

  refreshData = () => {
    const { refreshinterval } = this.props;
    if (refreshinterval && this.state?.currentData?.live) {
      this.electionWidgetInterval = setInterval(() => {
        this.props.loadAjaxResultData(this.state?.currentData?.exitPollObject);
      }, refreshinterval * 1000);
    }
  };

  componentDidMount() {
    this.refreshData();
  }

  componentWillUnmount() {
    clearInterval(this.electionWidgetInterval);
  }

  onTabsChange = params => {
    const { exitPollObject } = params.clickedItem;
    this.setState({ currentData: params.clickedItem });
    this.props.loadAjaxResultData(exitPollObject, true);
  };

  setActiveTab = tabNum => {
    this.setState({
      activeTab: tabNum?.index ? Number(tabNum?.index) : this.state.activeTab,
    });
  };

  renderElection() {
    const { electionData } = this.props?.sectionData?.items || {};
    const {
      isWapView,
      states = [],
      sortedData,
      infoMsg,
      infoMsgCommon,
      alMasterMap,
      prMasterMap,
      starCandidateData,
      seatArrangementVS,
    } = this.props;
    const powerStates =
      (states &&
        Array.isArray(states) &&
        states.filter(str => str.powerState === '1')) ||
      [];

    const lokSabhaStateMap = sortedData?.states || {};

    const lokSabhaStates = Object.values(lokSabhaStateMap) || [];
    let lokSabhaStatesForStates = JSON.parse(JSON.stringify(lokSabhaStates));

    if (this.props.isStatesPage) {
      lokSabhaStatesForStates = lokSabhaStatesForStates.sort(
        (a, b) => b.ttl_seats - a.ttl_seats,
      );
    }

    this.tabRefs = powerStates.reduce((acc, tab) => {
      acc[tab.key] = React.createRef();
      return acc;
    }, {});

    const { activeTab } = this.state;
    const tabs = [
      { name: 'Alliance View', index: 1 },
      { name: 'Party View', index: 2 },
    ];

    let { activeTabObject } = this.state;

    if (!activeTabObject && !isWapView) {
      activeTabObject = powerStates.slice(0, 1);
    } else if (!activeTabObject && isWapView) {
      activeTabObject = powerStates.slice(0, 1);
    }
    const currentActiveTab = activeTabObject;
    const slideIndex =
      powerStates instanceof Array &&
      powerStates.findIndex(
        st =>
          typeof st !== 'undefined' &&
          currentActiveTab &&
          Array.isArray(currentActiveTab) &&
          currentActiveTab.length > 0 &&
          st.key === currentActiveTab[0].key,
      );
    if (slideIndex > -1 && this.slider) {
      this.slider.slickGoTo(slideIndex);
    }

    return (
      <>
        <div className={s.switchTabsWrap} ref={this.stateResultWrapRef}>
          {!this.props.isStatesPage && (
            <SwitchTabs tabs={tabs} tabHandler={this.setActiveTab} />
          )}
          {this.props.isStatesPage && <Listingheader headingname="States" />}
          <div className={s.tabs}>
            <span>Year :</span>{' '}
            <HeaderTab
              subSections={Object.values(electionData)
                .filter(ed => ed.resultUrl)
                .sort((a, b) => b.year - a.year)
                .map(ed => ({
                  ...ed,
                  url: ed.resultUrl,
                  link: ed.resultUrl,
                }))}
              onChangeCallback={this.onTabsChange}
            />
          </div>
        </div>
        {!this.props.isStatesPage && (
          <>
            <div className={s.seatWrap}>
              <div className={s.boxStyle}>
                <AdCaller
                  immediateLoad
                  data={{
                    jname: 'rsltdayew',
                  }}
                />
                {seatArrangementVS === '1' ? (
                  <LokSabhaSeatingVS
                    disabledSeats={sortedData?.disableSeatCount}
                    parties={
                      activeTab === 1
                        ? sortedData?.al_rslt
                        : sortedData?.starpr_rslt
                    }
                    colorMap={activeTab === 1 ? alMasterMap : prMasterMap}
                    totalSeats={sortedData?.ttl_seats}
                    activeSeats={sortedData?.activeSeats}
                    leadPlusWinCount={sortedData?.leadPlusWinCount}
                    leadObject={
                      activeTab === 1
                        ? sortedData?.leadingAllianceObj
                        : sortedData?.leadingPartyObj
                    }
                    infoMsg={infoMsg}
                    majority={sortedData.majority}
                  />
                ) : (
                  <LokSabhaSeating
                    disabledSeats={sortedData?.disableSeatCount}
                    parties={
                      activeTab === 1
                        ? sortedData?.al_rslt
                        : sortedData?.starpr_rslt
                    }
                    colorMap={activeTab === 1 ? alMasterMap : prMasterMap}
                    totalSeats={sortedData?.ttl_seats}
                    activeSeats={sortedData?.activeSeats}
                    leadPlusWinCount={sortedData?.leadPlusWinCount}
                    leadObject={
                      activeTab === 1
                        ? sortedData?.leadingAllianceObj
                        : sortedData?.leadingPartyObj
                    }
                    infoMsg={infoMsg}
                    majority={sortedData.majority}
                  />
                )}
                <div className={s.miniResultWrap}>
                  <MiniResultStatus
                    parties={
                      activeTab === 1
                        ? sortedData?.al_rslt
                        : sortedData?.starpr_rslt
                    }
                    colorMap={activeTab === 1 ? alMasterMap : prMasterMap}
                    isExitPoll={false}
                    noBorder
                    cntCntr
                    totalSeats={sortedData.ttl_seats}
                  />
                </div>

                <div className={s.ctaWrap}>
                  <Morebtn
                    moreText="Party Tally"
                    moreLink={`${TOI_LIVE_DOMAIN}/elections/lok-sabha-elections/parties`}
                    redbg
                  />
                  <Morebtn
                    moreText="View Map"
                    moreLink={`${TOI_LIVE_DOMAIN}/elections/constituency-map`}
                    redBrdr
                  />
                </div>
              </div>
            </div>
            {infoMsgCommon && (
              <div className={s.infoMsgCommon}>{infoMsgCommon}</div>
            )}
            <div className={`${s.changeTableWrap}`}>
              <SeatChangeTable
                currentYear={this.state?.currentData?.year}
                lastYear={this.state?.currentData?.prevYear}
                isWapView={isWapView}
                parties={
                  activeTab === 1
                    ? sortedData?.al_rslt
                    : sortedData?.starpr_rslt
                }
                partyView={activeTab !== 1}
                colorMap={activeTab === 1 ? alMasterMap : prMasterMap}
                logo={activeTab !== 1}
                leadPlusWinCount={sortedData?.leadPlusWinCount}
                activeSeats={sortedData?.activeSeats}
                leadObject={
                  activeTab === 1
                    ? sortedData?.leadingAllianceObj
                    : sortedData?.leadingPartyObj
                }
              />
            </div>
            {starCandidateData &&
              Array.isArray(starCandidateData) &&
              starCandidateData.length > 0 && (
                <div className={s.electionBattleWrap}>
                  <ElectionBattle
                    isWapView={isWapView}
                    infiniteScroll={false}
                    slidesToShow={4}
                    slidesToScroll={4}
                    adactive
                    candidateLinking={this.state?.currentData?.candidateLinking}
                    starCandidateData={starCandidateData.filter(candidates => {
                      if (typeof candidates?.star === 'string') {
                        return candidates.star
                          .toLowerCase()
                          .split(',')
                          .includes('toi');
                      }
                      return false;
                    })}
                    blackArrow
                  />
                </div>
              )}
          </>
        )}
        {this.props.isStatesPage && (
          <div
            className={`${s.stateResultWrap} ${
              this.state.expandDiv ? s.show : ''
            }`}
          >
            <div className={s.inner}>
              <h5>State-Wise Lok Sabha seats</h5>
              <p>
                Distribution of Lok Sabha seats across states and union
                territories in India
              </p>
              {lokSabhaStatesForStates.map(state => (
                <div className={s.stateResultRow}>
                  <div className={s.stateResultFirstCol}>{state.nm}</div>
                  <div className={s.stateResulSecondCol}>
                    <div
                      className={s.bar}
                      style={{
                        width: `${state.ttl_seats}%`,
                      }}
                    />
                    <div className={s.stateResulThirdCol}>
                      {state.ttl_seats}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className={s.toggleBtn} onClick={this.toggleClass} />
          </div>
        )}
        {this.props.isStatesPage && (
          <div className={s.seatStrip}>
            <div className={s.totalSeats}>
              {sortedData?.leadPlusWinCount && (
                <div className={s.leadWins}>
                  {sortedData?.leadPlusWinCount?.winCount ===
                  sortedData?.activeSeats
                    ? 'Results'
                    : 'Leads + Wins'}
                </div>
              )}:{' '}
              <span>
                {sortedData?.leadPlusWinCount?.leadPlusWinCount}/{
                  sortedData?.ttl_seats
                }
              </span>{' '}
              {infoMsg && <InfoMsg msg={infoMsg} />}
            </div>
            <div className={s.resultStatus}>
              <span
                style={{
                  color:
                    activeTab === 1
                      ? sortedData?.leadingAllianceObj.color
                      : sortedData?.leadingPartyObj.color,
                }}
              >
                {activeTab === 1
                  ? sortedData?.leadingAllianceObj.party
                  : sortedData?.leadingPartyObj.party}
              </span>{' '}
              {activeTab === 1
                ? sortedData?.leadingAllianceObj.text
                : sortedData?.leadingPartyObj.text}
            </div>
          </div>
        )}
        <Listingheader headingname="Power States" />
        <StateWrapper>
          {lokSabhaStates &&
          Array.isArray(lokSabhaStates) &&
          lokSabhaStates.length > 0 ? (
            <>
              {powerStates &&
                Array.isArray(powerStates) &&
                powerStates.length > 0 &&
                powerStates.map(ps => (
                  <MiniResultStatus
                    parties={
                      activeTab === 1
                        ? lokSabhaStateMap?.[ps.key]?.al_rslt
                        : lokSabhaStateMap?.[ps.key]?.starpr_rslt
                    }
                    isExitPoll={false}
                    activeSeats={
                      lokSabhaStateMap?.[ps.key]?.activeSeats ||
                      lokSabhaStateMap?.[ps.key]?.ttl_seats
                    }
                    infoMsg={lokSabhaStateMap?.[ps.key]?.infoMsg}
                    name={lokSabhaStateMap?.[ps.key]?.nm}
                    path={`${TOI_LIVE_DOMAIN}/elections/constituency-map/${createSlug(
                      lokSabhaStateMap?.[ps.key]?.seonm,
                    )}`}
                    colorMap={activeTab === 1 ? alMasterMap : prMasterMap}
                    totalSeats={lokSabhaStateMap?.[ps.key]?.ttl_seats}
                  />
                ))}
            </>
          ) : (
            <div className="noDataFound">No other State data</div>
          )}
        </StateWrapper>
        {this.props?.sectionData?.items?.banner && (
          <>
            <AdCaller data={{ jname: 'rsltdayewbottom' }} immediateLoad />
            <div className={s.bannerSliderWrap}>
              {!isWapView ? (
                <BannerSlider
                  key={this.props?.sectionData?.items?.banner.tn}
                  data={this.props?.sectionData?.items?.banner}
                  gaAction="ElectionBannerWidget_Click"
                  gaLabelPerfix="election_banner/click/"
                />
              ) : (
                <BannerSliderMobile
                  key={this.props?.sectionData?.items?.banner.tn}
                  data={this.props?.sectionData?.items?.banner}
                  gaAction="ElectionBannerWidget_Click"
                  gaLabelPerfix="election_banner/click/"
                />
              )}
            </div>
          </>
        )}
        <Listingheader headingname="Other States" />
        <StateWrapper>
          {lokSabhaStates.map(
            unPowerStates =>
              unPowerStates.powerState !== '1' && (
                <MiniResultStatus
                  parties={
                    activeTab === 1
                      ? unPowerStates?.al_rslt
                      : unPowerStates?.starpr_rslt
                  }
                  isExitPoll={false}
                  activeSeats={
                    unPowerStates?.activeSeats || unPowerStates?.ttl_seats
                  }
                  infoMsg={unPowerStates?.infoMsg}
                  name={unPowerStates?.nm}
                  path={`${TOI_LIVE_DOMAIN}/elections/constituency-map/${createSlug(
                    unPowerStates?.seonm,
                  )}`}
                  colorMap={activeTab === 1 ? alMasterMap : prMasterMap}
                  totalSeats={unPowerStates?.ttl_seats}
                />
              ),
          )}
        </StateWrapper>
      </>
    );
  }

  render() {
    return (
      <div className={s.resultlWidgetWrapper} ref={this.ref}>
        {this.props.dataLoading && <LoaderSpinner />}
        {this.state?.currentData &&
          this.state?.currentData?.note && (
            <p className={s.noteText}>{this.state?.currentData?.note}</p>
          )}
        <div className="mt">{this.renderElection()}</div>
        {this.state?.currentData?.source && (
          <div className={`${s.sourceText} ${s.cl}`}>
            Source: {this.state?.currentData?.source}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  refreshinterval: state?.lokSabhaElection?.refreshinterval,
  electionData: state?.lokSabhaElection?.electionData,
  dataLoading: state?.lokSabhaElection?.dataLoading,
  starCandidateData: state?.lokSabhaElection?.starCandidateData,
  isExitPoll: state?.lokSabhaElection?.isExitPoll,
  displaytext: state?.lokSabhaElection?.displaytext,
  keywords: state?.lokSabhaElection?.keywords,
  breakingnews: state?.lokSabhaElection?.breakingnews,
  states: state?.lokSabhaElection?.states,
  liveblog: state?.lokSabhaElection?.liveblog,
  datasource: state?.lokSabhaElection?.datasource,
  hideexitheading: state?.lokSabhaElection?.hideexitheading,
  path: state?.lokSabhaElection?.path,
  exitPollStateData: state?.lokSabhaElection?.exitPollStateData,
  sortedData: state?.lokSabhaElection?.sortedData,
  infoMsg: state?.lokSabhaElection?.infoMsg,
  infoMsgCommon: state?.lokSabhaElection?.infoMsgCommon,
  prMasterMap: state?.lokSabhaElection?.prMasterMap,
  alMasterMap: state?.lokSabhaElection?.alMasterMap,
  seatArrangementVS: state?.lokSabhaElection?.seatArrangementVS,
});

const mapDispatchToProps = dispatch => ({
  loadAjaxResultData: (resultObject, loader = false) => {
    dispatch(loadLokSabhaResult(resultObject, loader));
  },
});

LoksabhaElectionResultWrapper.propTypes = {
  isWapView: PropTypes.bool,
  data: PropTypes.shape({
    items: PropTypes.shape({}),
  }),
};
LoksabhaElectionResultWrapper.defaultProps = {
  isWapView: false,
  data: {},
};

export default connect(mapStateToProps, mapDispatchToProps)(
  LoksabhaElectionResultWrapper,
);
